import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ValidationResult } from '../models';
import { ValidationErrorPopupState } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ValidationResultService {
  private _state = new BehaviorSubject<ValidationErrorPopupState>({
    visible: false,
  });
  state$ = this._state.asObservable();

  show(message: ValidationResult) {
    this._state.next({ visible: true, message });
  }

  hide() {
    this._state.next({ visible: false });
  }
}
